<template>
  <v-card class="mb-3">
    <v-card-text class="mb-0 pb-0">
      <v-row>
        <v-col cols="12">
          <el-pastas
            email
            label="El. pašto adresas"
            tooltip="Modalas asmuo. El paštas"
            :readonly="readonly"
            need
            v-model="pastas"
            :autofocus="autofocus"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ElAsmuoPastas',
  props: {
    value: String,
    readonly: Boolean,
    autofocus: { type: Boolean, default: false },
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    pastas: {
      get() {
        return this.value
      },
      set(elValue) {
        this.$emit('input', elValue)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/elements.scss';
</style>
